import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';

import * as authActions from './auth.actions';
import * as authSelectors from './auth.selectors';

import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { IExtraData, IPutRecord } from '../../../core/models/app.model';
import { IAuthCustomer } from '../../../core/models/auth.model';
import { AuthAPI } from '../../../data/mo-api/auth.api';
import { AppFacade } from '../../../facades/app.facade';
import { AuthFacade } from '../../../facades/auth.facade';
import { EVENTS } from '../../../data/events/events-by-category';

@Injectable()
export class AuthEffects {
  constructor(
    private _store: Store,
    private actions$: Actions,
    private _authAPI: AuthAPI,
    private _appFacade: AppFacade,
    private _authFacade: AuthFacade
  ) {}

  public requestLoginCode$ = createEffect(() =>
    this.actions$.pipe(
      ofType(authActions.requestLoginCode),
      withLatestFrom(this._store.select(authSelectors.selectCaptcha)),
      switchMap(([{ phone, resend }, token]) =>
        this._authAPI.requestLoginCode(phone, token).pipe(
          tap((customer) => {
            const data: IPutRecord = EVENTS.REGISTER.PHONE.REQUEST;
            const extraData: IExtraData = { request: { phone, resend }, response: customer };
            this._appFacade.sendPutRecord(data, extraData);
          }),
          map((customer: IAuthCustomer) => {
            const event: IPutRecord = EVENTS.REGISTER.PHONE.EVENT;
            this._appFacade.setIsLoading();
            this._authFacade.saveAuthCustomer(customer);
            if (!resend) this._appFacade.nextStep();
            this._appFacade.sendPutRecord(event);
            return authActions.successRequestLoginCode({ customer });
          }),
          catchError((error) => {
            const data: IPutRecord = EVENTS.REGISTER.PHONE.REQUEST;
            const extraData: IExtraData = {
              request: { phone, resend },
              response: { error: error?.error ?? error },
            };
            this._appFacade.sendPutRecord(data, extraData);
            return of(authActions.failureRequestLoginCode({ message: error }));
          })
        )
      )
    )
  );

  public setCaptcha$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(authActions.setCaptcha),
        withLatestFrom(this._store.select(authSelectors.selectPhone)),
        tap(([{ token }, phone]) => {
          return this._authFacade.requestLoginCode(phone, true, token);
        })
      ),
    { dispatch: false }
  );
}
